export const KEYS = {
  ID_TOKEN: 'kc_token',
  REFRESH_TOKEN: 'kc_refreshToken',
  TIMESKEW: 'kc_timeSkew',
}

export function getIdToken() {
  return localStorage.getItem(KEYS.ID_TOKEN)
}

export function getTokens() {
  return {
    token: localStorage.getItem(KEYS.ID_TOKEN),
    refreshToken: localStorage.getItem(KEYS.REFRESH_TOKEN)
  }
}

export function updateLocalStorage({ token, refreshToken, timeSkew }) {
  if (token) localStorage.setItem(KEYS.ID_TOKEN, token)
  if (refreshToken) localStorage.setItem(KEYS.REFRESH_TOKEN, refreshToken)
  if (timeSkew) localStorage.setItem(KEYS.TIMESKEW, timeSkew)
}
